import React, { PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { listViewStyles } from '../../../styles';
import { ISocialMediaPost } from '../../../../dataObjects/models/digitalMedia/SocialMediaPost';
import SocialMediaPostsListViewItem from './SocialMediaPostsListViewItem';
import { ISocialMediaPostViewModel } from '../../../../dataObjects/viewModels/socialMediaPostViewModel';

export interface ISocialMediaPostsListViewProps extends PropsWithChildren<unknown> {
  socialMediaPostViewModels: Array<ISocialMediaPostViewModel>;
  onDelete: (socialMediaPost: ISocialMediaPost) => void;
}

export const SocialMediaPostsListView: React.FC<ISocialMediaPostsListViewProps> = (props: ISocialMediaPostsListViewProps) => {
  SocialMediaPostsListView.displayName = 'SocialMediaPosts List View';

  // eslint-disable-next-line no-console
  // console.info(`Render SocialMediaPostsListView`);

  const classes: Record<string, string> = listViewStyles();

  const { socialMediaPostViewModels, onDelete } = props;

  return (
    <>
      {/* overall grid for list. There will be a header row and two data rows: 
          - Header Row
          - Data Row 1: Title (with SocialMediaPost) & Action Buttons
          - Data Row 2: Description
      */}
      <Grid container direction="column" >
        {/* Header Row */}
        <Grid key='tableHeader' container className={classes.tableHeader} size={12} direction="row">
          <Grid key='titleAndContentLabel' size={{ xs: 12, md: 10 }} >
            <Typography variant='h6'>
              Title (SocialMediaPost) / Description
            </Typography>
          </Grid>
          <Grid container size={{ md: 2 }} direction="row" justifyContent="center" alignContent="flex-start">
            <Grid key='editLabel' container className={classes.actionButtonLabelContainer} size={{ md: 4 }} justifyContent='center' >
              {/* Only display the next label if the screen size is Medium or larger */}
              <Box sx={{ display: { xs: 'none', md: 'block' } }} >
                <Typography variant='h6'>
                  Edit
                </Typography>
              </Box>
            </Grid>
            <Grid key='deleteLabel' container className={classes.actionButtonLabelContainer} size={{ md: 4 }} justifyContent='center' >
              {/* Only display the next label if the screen size is Medium or larger */}
              <Box sx={{ display: { xs: 'none', md: 'block' } }} >
                <Typography variant='h6'>
                  Delete
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        {
          socialMediaPostViewModels.map((socialMediaPostViewModel, idx) => (
            <SocialMediaPostsListViewItem
              key={socialMediaPostViewModel.socialMediaPost.id}
              socialMediaPostViewModel={socialMediaPostViewModel}
              onDelete={onDelete}
            />
          ))
        }
      </Grid>
    </>
  );
};

export default SocialMediaPostsListView;
